var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrandCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 38",
    "aria-labelledby": "brandCardIcon brandCardDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M0 0v38h60V0zm4 4.1c8.1.1 28.7-.1 31.1-.1-2.7 1.7-3.7 6-3.9 8.5h9.7c.5-3.7 3.7-4.9 6.5-4.9 3.1 0 6.5.7 6.5 3.9-.7 3-3.8 3.2-6.1 3.5-4.1.5-8.8.8-12.3 2.7-3.7 2-5.5 5.2-5.5 9.6 0 2.7.7 4.9 2.2 6.7H4zM9 13c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm44.3 5.6v3.5c-.2 5.5-4.1 8.3-8.9 8.3-2.9-.1-5-2-5-4.6.5-4.1 3.9-4.7 7-5.3 2.5-.4 4.8-.8 6.9-1.9z"
  })));
}

export default SvgBrandCard;